import(/* webpackMode: "eager" */ "/codebuild/output/src4122767702/src/apps/webapp/src/app/global-error.tsx");
